import type { CSSProperties } from 'react';

/** Shared control styles — 07-11 size.control.height / PRM state matrix */
export const controlMinHeight: CSSProperties = {
  minHeight: 'var(--size-control-height)',
};

export const labelStyle: CSSProperties = {
  fontSize: 'var(--type-label)',
  fontWeight: 'var(--font-weight-medium)',
  color: 'var(--color-text-default)',
};

export const fieldGap: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  gap: 'var(--space-field-label-gap)',
};

export const choiceLabelStyle: CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 'var(--space-inline-gap)',
  minHeight: 'var(--size-control-height)',
  cursor: 'pointer',
};

export function errorMessageId(fieldId: string | undefined): string | undefined {
  return fieldId ? `${fieldId}-error` : undefined;
}

export function controlBorder(error?: string): string {
  return error ? 'var(--color-border-error)' : 'var(--color-border-strong)';
}

/**
 * Shared Tailwind class fragments for the state matrix in 07-11.
 * `hov:` is the floor-suppressed hover variant declared in tailwind.css.
 */

/** Text entry surface shared by PRM-03, PRM-04, PRM-05, PRM-06, PRM-07. */
export const controlSurface =
  'w-full rounded-control bg-raised px-field text-body text-default placeholder:text-placeholder';

/** Disabled: remains in the accessibility tree, remains focusable, reason readable. */
export const controlDisabled =
  'aria-disabled:cursor-not-allowed aria-disabled:bg-off aria-disabled:text-disabled';

/** Loading: retains its bounding box so layout does not shift. */
export const controlLoading = 'aria-busy:cursor-progress aria-busy:opacity-70';

export const controlHover = 'hov:border-line-focus';

export const controlFocus = 'focus-ring';

export function controlBorderClass(error?: string): string {
  return error ? 'border border-line-danger' : 'border border-line-strong';
}

/** Minimum target size: 44px standard/dense, 56px floor — never via the 2.5.8 spacing exception. */
export const minTarget = 'min-h-target min-w-target';

/** Checkbox, radio and switch labels are themselves click targets (07-11 PRM-08). */
export const choiceLabelClass =
  'inline-flex min-h-control cursor-pointer items-center gap-inline text-body text-default';
